import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import * as THREE from 'three';
import CRS from "./Geographic/Crs";
import { geoidLayerIsVisible } from "../Layer/GeoidLayer";

/**
 * A TileMesh is a THREE.Mesh with a geometricError and an OBB
 * The objectId property of the material is the with the id of the TileMesh
 * @constructor
 * @param {TileGeometry} geometry - the tile geometry
 * @param {THREE.Material} material - a THREE.Material compatible with THREE.Mesh
 * @param {Layer} layer - the layer the tile is added to
 * @param {Extent} extent - the tile extent
 * @param {?number} level - the tile level (default = 0)
 */
var _tms = /*#__PURE__*/new WeakMap();
var _visible = /*#__PURE__*/new WeakMap();
var TileMesh = /*#__PURE__*/function (_THREE$Mesh) {
  _inherits(TileMesh, _THREE$Mesh);
  var _super = _createSuper(TileMesh);
  function TileMesh(geometry, material, layer, extent) {
    var _this;
    var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    _classCallCheck(this, TileMesh);
    _this = _super.call(this, geometry, material);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _tms, {
      writable: true,
      value: new Map()
    });
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _visible, {
      writable: true,
      value: true
    });
    if (!extent) {
      throw new Error('extent is mandatory to build a TileMesh');
    }
    _this.layer = layer;
    _this.extent = extent;
    _this.extent.zoom = level;
    _this.level = level;
    _this.material.objectId = _this.id;
    _this.obb = _this.geometry.OBB.clone();
    _this.boundingSphere = new THREE.Sphere();
    _this.obb.box3D.getBoundingSphere(_this.boundingSphere);
    var _iterator = _createForOfIteratorHelper(layer.tileMatrixSets),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var tms = _step.value;
        _classPrivateFieldGet(_assertThisInitialized(_this), _tms).set(tms, _this.extent.tiledCovering(tms));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    _this.frustumCulled = false;
    _this.matrixAutoUpdate = false;
    _this.rotationAutoUpdate = false;
    _this.layerUpdateState = {};
    _this.isTileMesh = true;
    _this.geoidHeight = 0;
    _this.link = {};
    Object.defineProperty(_assertThisInitialized(_this), 'visible', {
      get: function get() {
        return _classPrivateFieldGet(this, _visible);
      },
      set: function set(v) {
        if (_classPrivateFieldGet(this, _visible) != v) {
          _classPrivateFieldSet(this, _visible, v);
          this.dispatchEvent({
            type: v ? 'shown' : 'hidden'
          });
        }
      }
    });
    return _this;
  }
  /**
   * If specified, update the min and max elevation of the OBB
   * and updates accordingly the bounding sphere and the geometric error
   *
   * @param {Object}  elevation
   * @param {number}  [elevation.min]
   * @param {number}  [elevation.max]
   * @param {number}  [elevation.scale]
   */
  _createClass(TileMesh, [{
    key: "setBBoxZ",
    value: function setBBoxZ(elevation) {
      elevation.geoidHeight = geoidLayerIsVisible(this.layer) ? this.geoidHeight : 0;
      this.obb.updateZ(elevation);
      if (this.horizonCullingPointElevationScaled) {
        this.horizonCullingPointElevationScaled.setLength(this.obb.z.delta + this.horizonCullingPoint.length());
      }
      this.obb.box3D.getBoundingSphere(this.boundingSphere);
    }
  }, {
    key: "getExtentsByProjection",
    value: function getExtentsByProjection(crs) {
      return _classPrivateFieldGet(this, _tms).get(CRS.formatToTms(crs));
    }

    /**
     * Search for a common ancestor between this tile and another one. It goes
     * through parents on each side until one is found.
     *
     * @param {TileMesh} tile
     *
     * @return {TileMesh} the resulting common ancestor
     */
  }, {
    key: "findCommonAncestor",
    value: function findCommonAncestor(tile) {
      if (!tile) {
        return undefined;
      }
      if (tile.level == this.level) {
        if (tile.id == this.id) {
          return tile;
        } else if (tile.level != 0) {
          return this.parent.findCommonAncestor(tile.parent);
        } else {
          return undefined;
        }
      } else if (tile.level < this.level) {
        return this.parent.findCommonAncestor(tile);
      } else {
        return this.findCommonAncestor(tile.parent);
      }
    }
  }, {
    key: "onBeforeRender",
    value: function onBeforeRender() {
      if (this.material.layersNeedUpdate) {
        this.material.updateLayersUniforms();
      }
    }
  }]);
  return TileMesh;
}(THREE.Mesh);
export default TileMesh;